import { cn } from '@/lib/utils'

export function RadioGroup({
  label,
  options = [],
  value,
  onChange,
  required,
  error,
  hint,
  columns = 'auto',
  allowClear = false,
  className,
}) {
  const select = (v) => {
    if (allowClear && value === v) {
      onChange?.(null)
    } else {
      onChange?.(v)
    }
  }

  const gridCols =
    columns === 'auto'
      ? 'grid-cols-2 sm:grid-cols-3'
      : columns === 1
        ? 'grid-cols-1'
        : columns === 2
          ? 'grid-cols-1 sm:grid-cols-2'
          : 'grid-cols-2 sm:grid-cols-3'

  return (
    <div className={cn('w-full', className)}>
      {label && (
        <p className="mb-1.5 text-sm font-semibold text-ink-800">
          {label}
          {required && <span className="ml-0.5 text-accent-600">*</span>}
        </p>
      )}
      <div className={cn('grid gap-2', gridCols)}>
        {options.map((opt) => {
          const checked = value === opt.value
          return (
            <button
              type="button"
              key={opt.value}
              onClick={() => select(opt.value)}
              className={cn(
                'group flex items-center gap-3 rounded-xl px-3.5 py-2.5 text-left text-sm font-medium',
                'ring-1 ring-inset transition-all duration-150',
                checked
                  ? 'bg-primary-50 text-primary-900 ring-primary-300 shadow-soft'
                  : 'bg-white text-ink-700 ring-ink-200 hover:ring-ink-300 hover:bg-ink-50/40',
              )}
            >
              <span
                className={cn(
                  'flex h-5 w-5 shrink-0 items-center justify-center rounded-full ring-1 transition-all',
                  checked
                    ? 'bg-cream ring-primary-700'
                    : 'bg-white ring-ink-300 group-hover:ring-ink-400',
                )}
              >
                {checked && (
                  <span className="h-2.5 w-2.5 rounded-full bg-primary-700" />
                )}
              </span>
              <span className="truncate">{opt.label}</span>
            </button>
          )
        })}
      </div>
      {error ? (
        <p className="mt-1.5 text-xs font-medium text-rose-600">{error}</p>
      ) : hint ? (
        <p className="mt-1.5 text-xs text-ink-500">{hint}</p>
      ) : null}
    </div>
  )
}
